import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'Store';
import { DEFAULT_MINI_EPG_LIST_MODE } from '../../../options';

// TODO: Refactor into TS Interface
export const EpgListModeContext = createContext({
    // eslint-disable-next-line no-new-wrappers
    miniEpgSelectedListMode: new String(),
    // eslint-disable-next-line no-unused-vars
    setMiniEpgSelectedListMode: (_listMode) => {}
});

export const EpgListModeContextProvider = ({ children }) => {
    const [miniEpgSelectedListMode, setMiniEpgSelectedListMode] = useState(
        DEFAULT_MINI_EPG_LIST_MODE
    );
    const { epgSelectedListMode } = useStore();

    // Mini epg dependent on regular epg filter state
    useEffect(() => {
        if (epgSelectedListMode !== miniEpgSelectedListMode)
            setMiniEpgSelectedListMode(epgSelectedListMode);
    }, [epgSelectedListMode]);

    return (
        <EpgListModeContext.Provider
            value={{
                miniEpgSelectedListMode,
                setMiniEpgSelectedListMode
            }}
        >
            {children}
        </EpgListModeContext.Provider>
    );
};

EpgListModeContextProvider.defaultProps = {
    children: []
};

EpgListModeContextProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export const useEpgListMode = () => useContext(EpgListModeContext);

export const withEpgListMode = (Component) => (props) =>
    (
        <EpgListModeContext.Consumer>
            {(context) => <Component {...props} {...context} />}
        </EpgListModeContext.Consumer>
    );
